// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"DesktopFeedPanoramaAd_adContainer__re5o1","adContent":"DesktopFeedPanoramaAd_adContent__93esa"};